<template>
  <v-app id="app">
    <!-- <div class="app-body"> -->
    <header-component/>
    <router-view v-if="isAuthLoading === true"></router-view>
    <footer-component class="footer"/>
    <!-- </div> -->
  </v-app>
</template>

<script>
import HeaderComponent from '@components/HeaderComponent'
import FooterComponent from '@components/FooterComponent'
export default {
  name: 'App',
  components: { HeaderComponent, FooterComponent },
  computed: {
    isAuthLoading() {
      return this.$store.getters.authorizeLoading
    }
  },
  created () {
    console.info('MMPT - app started')
     // force open edge
    let isIE = /*@cc_on!@*/false || !!document.documentMode;
	  let isEdge = !isIE && !!window.StyleMedia;
	  if(!isEdge) {
      let url = window.location;
      window.location="microsoft-edge:" + url;
    }
  },
  async mounted () {
    // await this.$msal.initMsal();
    // this.$store.dispatch('INIT_MASTER')
  },
  async beforeCreate() {
     await this.$msal.initMsal();
    this.$store.dispatch('INIT_MASTER')
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #dedede;
  // margin-top: 60px;
}

.footer {
  position: relative;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
}
@import '@scss/override.scss'
</style>
